import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
import { Button } from "react-bootstrap";
import AccountMangerCreateModal from './AccountMangerCreateModal';
import AccountMangerEditModal from './AccountMangerEditModal';
import ViewModal from './View';

const AccountManagerPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Password',
            selector: row => row.password,
            sortable: true,
        },
        {
            name: 'Added By',
            // selector: row => row.addedBy,
            cell: (row) => (
                <span className='badge bg-info'>{row.addedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Updated By',
            // selector: row => row.updatedBy,
            cell: (row) => (
                <span className='badge bg-info'>{row.updatedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <div className="hstack gap-1 fs-1">
                        <Button
                            aria-label="View"
                            onClick={() => setIsView(true)}
                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-eye-fill" />
                        </Button>
                        <Button
                            aria-label="Edit"
                            onClick={() => setIsEdit(true)}
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-edit-line" />
                        </Button>
                        <a
                            aria-label="Delete"
                            href="javascript:void(0);"
                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-delete-bin-7-line" />
                        </a>
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data = [
        {
            name: 'John Doe',
            email: 'john@example.com',
            password: "john@123",
            addedBy: 'Admin',
            updatedBy: 'User A',
            createdAt: '2024-03-09T12:00:00',
            updatedAt: '2024-03-09T13:30:00',
        },
        {
            name: 'Jane Smith',
            email: 'jane@example.com',
            password: "jane@123",
            addedBy: 'Admin',
            updatedBy: 'User B',
            createdAt: '2024-03-08T10:30:00',
            updatedAt: '2024-03-09T09:15:00',
        },
        {
            name: 'Michael Johnson',
            email: 'michael@example.com',
            password: "michael@123",
            addedBy: 'Admin',
            updatedBy: 'User C',
            createdAt: '2024-03-07T15:45:00',
            updatedAt: '2024-03-08T14:20:00',
        },
        {
            name: 'Emily Brown',
            email: 'emily@example.com',
            password: "emily@123",
            addedBy: 'Admin',
            updatedBy: 'User D',
            createdAt: '2024-03-06T11:20:00',
            updatedAt: '2024-03-07T16:40:00',
        },
        {
            name: 'David Lee',
            email: 'david@example.com',
            password: "david@123",
            addedBy: 'Admin',
            updatedBy: 'User E',
            createdAt: '2024-03-05T09:10:00',
            updatedAt: '2024-03-06T10:25:00',
        },
        {
            name: 'Sarah Taylor',
            email: 'sarah@example.com',
            password: "sarah@123",
            addedBy: 'Admin',
            updatedBy: 'User F',
            createdAt: '2024-03-04T14:30:00',
            updatedAt: '2024-03-05T11:55:00',
        },
        {
            name: 'William Wilson',
            email: 'william@example.com',
            password: "william@123",
            addedBy: 'Admin',
            updatedBy: 'User G',
            createdAt: '2024-03-03T08:45:00',
            updatedAt: '2024-03-04T17:30:00',
        },
        {
            name: 'Olivia Anderson',
            email: 'olivia@example.com',
            password: "olivia@123",
            addedBy: 'Admin',
            updatedBy: 'User H',
            createdAt: '2024-03-02T10:00:00',
            updatedAt: '2024-03-03T12:20:00',
        },
        {
            name: 'Daniel Martinez',
            email: 'daniel@example.com',
            password: "daniel@123",
            addedBy: 'Admin',
            updatedBy: 'User I',
            createdAt: '2024-03-01T13:20:00',
            updatedAt: '2024-03-02T09:45:00',
        },
        {
            name: 'Sophia White',
            email: 'sophia@example.com',
            password: "sophia@123",
            addedBy: 'Admin',
            updatedBy: 'User J',
            createdAt: '2024-02-29T09:30:00',
            updatedAt: '2024-03-01T10:55:00',
        },
    ];

    return (
        <>
            <PageHeader name="Account Manager" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary" onClick={() => setIsShow(true)}>
                                            Create Account Manager
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <AccountMangerCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <AccountMangerEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            />
            <ViewModal
                show={isView}
                handleClose={() => setIsView(false)}
            />
        </>
    );
};

export default AccountManagerPage;